import React, { useState, useEffect } from "react";
import { Tag } from "@zendeskgarden/react-tags";
import { Field, Textarea } from "@zendeskgarden/react-forms";
import { Button } from "@zendeskgarden/react-buttons";
import Tips from "components/Tips";
import { Accordion } from "@zendeskgarden/react-accordions";
import { Anchor } from "@zendeskgarden/react-buttons";
import SheetSkeleton from "./SheetSkeleton";
import BackendApi from "api/backendApi";
import { getDateFormat } from "utils/tools";
import ZdAlert from "components/ZdAlert";
import NoIntent from "components/Icon/NoIntent";
import AlertIcon from "components/Icon/AlertIcon";
import { useSelector } from "redux/store";

const checkUserAuthStatus = async (authStatusQueryData) => {
  try {
    let authStatusRes = await BackendApi.checkAuthStatus(authStatusQueryData);
    console.log("Response from checkUserAuthStatus api request:", authStatusRes);

    if (!!authStatusRes && authStatusRes.code == 200 && !!authStatusRes.data) {
      return authStatusRes.data;
    }
  } catch (error) {
    console.error("Error making checkUserAuthStatus api request:", error);
  }
};
const customAlert = ({ message }) => {
  return <></>;
};

export default function SuggestionReply() {
  if (!!client) {
    console.log({ client });
  }
  const timeZone = useSelector((state) => state.user.time_zone);
  const appUserAuthDetail = useSelector((state) => state.user.app_user_auth_detail);

  const alertTypes = [
    {
      icon: <NoIntent />,
      titleColor: "#AD5918",
      textColor: "#2F3941",
      type: "noIntent",
      message: "It looks like our service isn't enabled for this ticket, please contact your admin",
      title: "No detectable intent",
    },
    {
      icon: <AlertIcon />,
      titleColor: "#AD5918",
      textColor: "#2F3941",
      type: "noAuth",
      message: "Please contact your admin to authorise the API access. ",
      title: "Sorry, we don’t have the API access",
    },
    {
      icon: <AlertIcon />,
      textColor: "#2F3941",
      type: "noSubscription",
      titleColor: "#AD5918",
      message: "Sorry, you need an active subscription to use this app.",
      title: "A subscription is required",
    },
    {
      icon: <AlertIcon />,
      textColor: "#2F3941",
      titleColor: "#AD5918",
      type: "multipleComments",
      message: "Our service automatically replies to the customer's first message only!",
      title: "Multiple comments  received",
    },
    {
      icon: <AlertIcon />,
      textColor: "#2F3941",
      titleColor: "#AD5918",
      type: "ticketStatus",
      message: "Reply suggestion to new/open ticket only!",
      title: "No reply suggestion",
    },
  ];
  let initParams = {
    customerIntent: "",
    suggestionReply: "",
    confidenceScore: 0.5,
    IsAutoReplied: true,
  };

  const unAuthorisedMessage =
    "We don’t currently have API access to your account. Please contact your administrator to grant the necessary authorization.";
  const unSubscribedMessage = "Please contact your administrator to subscribe to our service. Thank you!";
  const multipleCommentsMessage = "Auto reply to customer's first message only!";
  const autoRepliedMessage = "Customer's first message has been auto replied";
  const noReplySuggestionMessage = "No reply suggestion generated";
  const ticketStatusConditionMessage = "Auto reply to new/open ticket only!";

  const [isAuthorised, setIsAuthorised] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false); //whether has the valid subscription
  const [ticketInfo, setTicketInfo] = useState({});
  const [syncError, setSyncError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showSuggestionError, setShowSuggestionError] = useState(false);
  const [suggestionErrorMessage, setSuggestionErrorMessage] = useState();
  const [suggestionReplyInfo, setSuggestionReplyInfo] = useState(initParams);
  const [appRandomKey, setAppRandomKey] = useState(0);
  const [copyStatus, setCopyStatus] = useState(false);
  const [ticketDetailsResponse, setTicketDetailsResponse] = useState({});

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setSyncError(false);
      setIsAuthorised(false);
      setIsSubscribed(false);
      client.invoke("resize", { width: "100%", height: "580px" });

      if (!appUserAuthDetail) return;

      let appContextResponse = {};
      try {
        appContextResponse = await client.context();
        console.log("appContextResponse", appContextResponse);
      } catch (error) {
        console.log("appContextResponse error");
        throw error;
      }

      let appMetadataResponse = {};
      try {
        appMetadataResponse = await client.metadata();
        console.log("appMetadataResponse", appMetadataResponse);
      } catch (error) {
        console.log("appMetadataResponse error");
        throw error;
      }

      //instances are transient in some locations (like ticket sidebar), so if the ticket tab is closed that instance is destroyed, so we will not use instanceGuid
      const account = appContextResponse["account"];

      if (!account || !account.subdomain) {
        throw new Error("can not get the zendesk subdomain");
      }

      let appId = appMetadataResponse.appId;
      let installationId = appMetadataResponse.installationId;

      if (!appId || !installationId) {
        throw new Error("can not get the zendesk app metadata");
      }

      //get zendesk ticket information by zendesk client api
      let ticketDetailsResponse = {};
      const ticketPropsArray = [
        "ticket.id",
        "ticket.assignee",
        "currentUser",
        "ticket.brand",
        "ticket.comments",
        "ticket.tags",
        "ticket.status",
      ];

      try {
        ticketDetailsResponse = await client.get(ticketPropsArray);
        setTicketDetailsResponse(ticketDetailsResponse);
        console.log("ticketDetailsResponse", ticketDetailsResponse);
      } catch (error) {
        console.log("ticketDetailsResponse error");
        throw error;
      }
      const ticket_id = ticketDetailsResponse["ticket.id"];
      console.log("ticket_id", ticket_id);
      const ticket_assignee = ticketDetailsResponse["ticket.assignee"];
      const current_user = ticketDetailsResponse["currentUser"];
      const ticket_brand = ticketDetailsResponse["ticket.brand"];
      const ticket_comments = ticketDetailsResponse["ticket.comments"];
      const ticket_tags = ticketDetailsResponse["ticket.tags"];
      const ticket_status = ticketDetailsResponse["ticket.status"];
      let ticketInfoObj = {
        ticket_id,
        ticket_assignee,
        current_user,
        ticket_brand,
        ticket_comments,
        ticket_tags,
        ticket_status,
      };

      setTicketInfo(ticketInfoObj);
      console.log(ticketInfoObj);

      //ticket have multiple comments
      if (!!ticket_comments && ticket_comments.length > 1) {
        // ticket has been auto replied
        if (
          !!ticket_tags &&
          ticket_tags.length > 0 &&
          ticket_tags.includes("ai_ticket_reply") &&
          ticket_comments.length == 2
        ) {
          console.log("auto replied. no new customer message, fetch auto reply info");
        } else {
          //when ticket status is not new or open, not show suggestion reply
          if (!!ticket_status && (ticket_status != "new" && ticket_status != "open")) {
            setShowSuggestionError(true);
            setSuggestionErrorMessage(alertTypes[4]);
            setIsLoading(false);
            console.log("ticket status is not new or open");
            return;
          } else {
            setShowSuggestionError(true);
            setSuggestionErrorMessage(alertTypes[3]);
            setIsLoading(false);
            console.log("ticket have multiple comments");
            return;
          }
        }
      }

      /*
      //Call backend api to check the user authorisation status
      const authStatusQueryData = {
        subdomain: account.subdomain,
        appid: appId,
        installationid: installationId,
      };
      console.log("authStatusQueryData", authStatusQueryData);

      let authStatusDetailData = await checkUserAuthStatus(authStatusQueryData);
      console.log("authStatusDetailData", authStatusDetailData);

      let appUserId = null;
      if (!!authStatusDetailData) {
        setIsAuthorised(authStatusDetailData.isAuthorised);
        appUserId = authStatusDetailData.uuid;

        if (!authStatusDetailData.isAuthorised || !authStatusDetailData.uuid) {
          setShowSuggestionError(true);
          setSuggestionErrorMessage(alertTypes[1]);
          setIsAuthorised(false);
          setIsLoading(false);
          console.log("not authorized");
          return;
        }

        if (!authStatusDetailData.isSubscribed) {
          setShowSuggestionError(true);
          setSuggestionErrorMessage(alertTypes[2]);
          setIsSubscribed(false);
          setIsLoading(false);
          console.log("no subscription");
          return;
        }
      } else {
        throw new Error("can not get the authorization and subscription status");
      }
      */

      let appUserId = null;
      if (!!appUserAuthDetail) {
        setIsAuthorised(appUserAuthDetail.isAuthorised);
        appUserId = appUserAuthDetail.uuid;

        if (!appUserAuthDetail.isAuthorised || !appUserAuthDetail.uuid) {
          setShowSuggestionError(true);
          setSuggestionErrorMessage(alertTypes[1]);
          setIsAuthorised(false);
          setIsLoading(false);
          console.log("not authorized");
          return;
        }

        if (!appUserAuthDetail.isSubscribed) {
          setShowSuggestionError(true);
          setSuggestionErrorMessage(alertTypes[2]);
          setIsSubscribed(false);
          setIsLoading(false);
          console.log("no subscription");
          return;
        }
      } else {
        throw new Error("can not get the authorization and subscription status");
      }

      // call back end api to get the reply suggestion
      let getReplySuggestionRes = await BackendApi.getReplySuggestionFromUser({
        subdomain: account.subdomain,
        appUserId: appUserId,
        zendeskTicketId: ticket_id,
      });

      console.log("getReplySuggestionRes", getReplySuggestionRes);
      if (!!getReplySuggestionRes && !!getReplySuggestionRes.data && !!getReplySuggestionRes.data.customerIntent) {
        setSuggestionReplyInfo({
          customerIntent: !!getReplySuggestionRes.data.customerIntentLabel
            ? getReplySuggestionRes.data.customerIntentLabel
            : "",
          suggestionReply: !!getReplySuggestionRes.data.suggestionReply
            ? getReplySuggestionRes.data.suggestionReply
            : "",
          sentAt: getReplySuggestionRes.data.suggestionReplyCreatedTimestamp,
          confidenceScore: getReplySuggestionRes.data.confidenceScore,
          needAutoReply: getReplySuggestionRes.data.needAutoReply,
          IsAutoReplied: getReplySuggestionRes.data.IsAutoReplied,
        });
      } else {
        setShowSuggestionError(true);
        setSuggestionErrorMessage(alertTypes[0]);
        setIsLoading(false);
        console.log("no reply suggestion data generated");
        return;
      }
      setIsLoading(false);
    } catch (error) {
      // client.invoke('resize', { width: '100%', height: '200px' });
      setIsLoading(false);
      setSyncError(true);
      console.error("fetchData error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [client, appRandomKey, appUserAuthDetail]);

  useEffect(() => {
    console.log({ suggestionReplyInfo });
  }, [suggestionReplyInfo]);

  const handleInsertDraft = () => {
    if (!!client) {
      // Replace newlines with <br> tags
      const formattedReply = suggestionReplyInfo.suggestionReply.replace(/\n/g, "<br>");

      setCopyStatus(true);
      // Insert the formatted content
      client.invoke("comment.appendHtml", formattedReply);
    }
  };

  return (
    <div className="px-5">
      {/* <div onClick={fetchData}>111</div> */}
      {isLoading ? (
        <SheetSkeleton />
      ) : //  !!syncError ? (
      !!syncError ? (
        <div className="flex flex-col items-center justify-center mt-12">
          <ZdAlert icon={<AlertIcon />} title={"An error occurred"} titleColor={"#AD5918"}>
            please refresh the app!
            <div className=" mt-[20px]">
              <Anchor
                href="#default"
                onClick={() => {
                  setAppRandomKey(Math.random);
                }}
              >
                Refresh
              </Anchor>
            </div>
          </ZdAlert>
        </div>
      ) : showSuggestionError ? (
        <div className=" m-auto pt-12 flex justify-center">
          <ZdAlert
            icon={suggestionErrorMessage?.icon}
            textColor={suggestionErrorMessage?.textColor}
            titleColor={suggestionErrorMessage?.titleColor}
            title={suggestionErrorMessage?.title}
          >
            {suggestionErrorMessage.message}
          </ZdAlert>
        </div>
      ) : (
        <div>
          <div className="flex flex-col">
            <div className="flex justify-between my-[12px] py-[2px]">
              <Field>
                <div>
                  <Field.Label className="mb-[10px]">{suggestionReplyInfo.customerIntent}</Field.Label>
                </div>

                {/*<Field.Hint>Detected Intent</Field.Hint>*/}
              </Field>
              <div className="flex flex-col items-end">
                <Tag hue="#68737D" isPill className="h-[20px] w-[40px]">
                  <span>{suggestionReplyInfo.confidenceScore}</span>
                </Tag>
                {/*<Field.Hint>Confidence Score</Field.Hint>*/}
              </div>
            </div>
          </div>
          <Accordion level={4}>
            <Accordion.Section>
              <Accordion.Header>
                <Accordion.Label>Show customer’s message</Accordion.Label>
              </Accordion.Header>
              <Accordion.Panel>
                <div className="bg-[#DEEEED] rounded-md p-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        ticketDetailsResponse["ticket.comments"][ticketDetailsResponse["ticket.comments"].length - 1]
                          .value,
                    }}
                  />
                </div>
              </Accordion.Panel>
            </Accordion.Section>
          </Accordion>

          {/* </Field> */}
          <div>
            <Field.Label>Suggested Reply</Field.Label>
            <Field.Hint>
              <div
                className="reply-desc pl-[10px] border-l italic whitespace-pre-wrap text-[#2F3941] leading-[20lk px] border-[#2F3941] mt-[8px]"
                dangerouslySetInnerHTML={{ __html: suggestionReplyInfo.suggestionReply }}
              />
              {/*
              {suggestionReplyInfo.IsAutoReplied && (
                <div
                  className="reply-desc pl-[10px] border-l italic whitespace-pre-wrap text-[#2F3941] leading-[20lk px] border-[#2F3941] mt-[8px]"
                  dangerouslySetInnerHTML={{
                    __html:
                      ticketDetailsResponse["ticket.comments"][ticketDetailsResponse["ticket.comments"].length - 2]
                        .value,
                  }}
                />
              )} */}
            </Field.Hint>
          </div>

          <div className="text-[#68737D] leading-[20px ] mt-[12px]">
            This is a suggested reply based on the confidence score.
          </div>
          {copyStatus && (
            <div className="mt-[8px]">
              <Tips color="#038153">
                <span>Pasted</span>
              </Tips>
            </div>
          )}
          {suggestionReplyInfo.IsAutoReplied && (
            <div className="mt-[8px]">
              <Tips color="#68737D">
                <span>Sent at {getDateFormat(suggestionReplyInfo.sentAt, timeZone)}</span>
              </Tips>
            </div>
          )}

          {!suggestionReplyInfo.IsAutoReplied && (
            <div className="flex w-full justify-end">
              <Button isBasic onClick={handleInsertDraft}>
                Insert suggested reply
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
